import { useEffect, useState } from 'react';
import { SearchComponent } from './searchInput'
import { Toolbar } from './toolbar'
import { useListView } from "./view";
import { useQueryRequest } from './request';
import { initialQueryState } from '../../_metronic/helpers';
import { OrderFilter } from './orderFilterOption';
import { useIsWeb } from './helper';


/**
 * ListHeader Component
 * Renders the header for the list view, including search input and toolbar.
 * For dispatch type, shows pill-style DispatchFilter (Category + Status) above search/toolbar.
 * Displays the number of selected items when any are selected.
 */
const ListHeader = () => {
    const { selected } = useListView()
    return (
        <div className='card-header border-0 pt-6'>

            <SearchComponent />
            {/* begin::Card toolbar */}
            <div className='card-toolbar'>
                {selected.length > 0 &&
                    <div className='d-flex justify-content-end align-items-center'>
                        <div className='fw-semibolder me-5'>
                            <span className='me-2'>{selected.length}</span> Selected
                        </div>
                    </div>}
                <Toolbar />
            </div>
            {/* end::Card toolbar */}
        </div>
    )
}


export { ListHeader }


/**
 * OrderListHeader Component
 * Renders the header for the order list view with filter type selection (Quick, Suggested, Other).
 * Integrates search and order filter options based on selected filter type.
 * Resets query state when filter type changes.
 * @param {Object} props
 * @param {Function} props.orderFilter - Function to render order filter options.
 */
const OrderListHeader = ({ orderFilter }) => {
    // const { selected } = useListView()
    const isWeb = useIsWeb(768);
    const { updateState } = useQueryRequest()
    const [filterType, setFillerType] = useState('quick');
    useEffect(() => {
        if (filterType) {
            updateState({
                filter: { segment: null, category: null },
                search: null,
                ...initialQueryState
            })
        }
    }, [filterType])

    return (
        <div className={isWeb ? 'card-header border-0 pt-6 ' : 'card-header border-0 pt-6  p-0'}>
            <div className={isWeb ? 'card-title ' : 'd-flex flex-column '}>
                <div className="d-flex mb-3 mb-md-0 fw-semibold">
                    <button onClick={() => setFillerType('quick')} className={`btn ${filterType === 'quick' ? 'btn-success' : 'btn-dark'}  btn-sm h-30 fs-6 px-6 align-self-center me-2  text-nowrap`}>Quick </button>
                    <button onClick={() => setFillerType('suggested')} className={`btn ${filterType === 'suggested' ? 'btn-success' : 'btn-dark'} btn-sm  fs-6 px-6 align-self-center me-2 text-nowrap`}>Suggested </button>
                    <button onClick={() => setFillerType('other')} className={`btn ${filterType === 'other' ? 'btn-success' : 'btn-dark'} btn-sm px-6  fs-6 align-self-center me-2 text-nowrap`}>Other </button>
                </div>
                {filterType === 'quick' &&
                    <SearchComponent OptionalClass={'custom-serach'} searchTerm='' />
                }
            </div>

            <div className='card-toolbar'>

                {/* begin::Card toolbar */}
                {(filterType === 'suggested' || filterType === 'other') &&

                    <OrderFilter orderFilter={orderFilter} />

                }
                {/* end::Card toolbar */}
            </div>
        </div>
    )
}

export { OrderListHeader }

